import { lazy } from "react";

export const RegisterPage = lazy(() => import("./register/Register"));
export const LoginPage = lazy(() => import("./login/Login"));
export const VerifyPage = lazy(() => import("./verify/Verify"));
export const ConfirmEmailPage = lazy(
  () => import("./confirm-email/ConfirmEmail")
);
